import {OrbitControls} from "three/examples/jsm/controls/OrbitControls.js";
import GUI from "lil-gui";
import * as THREE from "three";

export default class Controls extends OrbitControls {
    gui = new GUI();

    camera;

    constructor(camera, domElement) {
        super(camera, domElement);

        this.camera = camera;
    }

    withCameraControls() {
        const cameraParams = {
            positionX: this.camera.position.x,
            positionY: this.camera.position.y,
            positionZ: this.camera.position.z,
            rotationX: 0,
            rotationY: 0,
            rotationZ: 0,
        };

        const paramsCopy = structuredClone( cameraParams );

        const updateCamera = () => {
            camera.position.set(cameraParams.positionX, cameraParams.positionY, cameraParams.positionZ);
            camera.rotation.set(
                THREE.MathUtils.degToRad(cameraParams.rotationX),
                THREE.MathUtils.degToRad(cameraParams.rotationY),
                THREE.MathUtils.degToRad(cameraParams.rotationZ)
            );
        }

        cameraParams.reset = () => {
            cameraParams.positionX = paramsCopy.positionX;
            cameraParams.positionY = paramsCopy.positionY;
            cameraParams.positionZ = paramsCopy.positionZ;
            cameraParams.rotationX = paramsCopy.rotationX;
            cameraParams.rotationY = paramsCopy.rotationY;
            cameraParams.rotationZ = paramsCopy.rotationZ;
            updateCamera();
        };

        this.gui.add( cameraParams, 'reset' ).name('Reset Camera');

        const positionFolder = this.gui.addFolder('Camera Position');
        positionFolder.add(cameraParams, 'positionX', -10, 10, 0.1).name('X').onChange(updateCamera);
        positionFolder.add(cameraParams, 'positionY', -10, 10, 0.1).name('Y').onChange(updateCamera);
        positionFolder.add(cameraParams, 'positionZ', -10, 10, 0.1).name('Z').onChange(updateCamera);

        const rotationFolder = this.gui.addFolder('Camera Rotation');
        rotationFolder.add(cameraParams, 'rotationX', -180, 180, 1).name('X (degrees)').onChange(updateCamera);
        rotationFolder.add(cameraParams, 'rotationY', -180, 180, 1).name('Y (degrees)').onChange(updateCamera);
        rotationFolder.add(cameraParams, 'rotationZ', -180, 180, 1).name('Z (degrees)').onChange(updateCamera);
    }

    add(object, property, value = null, max = null, step = null) {
        return this.gui.add( object, property, value, max, step );
    }

    folder(title) {
        return this.gui.addFolder( title );
    }
}